import { useEffect } from "react";

import { IAccountDtoAccountTypeEnum } from '@/dtos';
import { useMyMoneyFormStore } from '@/modules/UseMyMoney/stores';
import { CombinedAccountData } from '@/modules/UseMyMoney/widgets/AccountDetails/AccountDetails.types';

interface Props {
  combinedAccountsData?: CombinedAccountData[];
}

const useSetupHsaAccount = ({ combinedAccountsData }: Props) => {
  const { handleSetFormValues } = useMyMoneyFormStore();

  useEffect(() => {
    const firstAccount = combinedAccountsData?.[0];
    if (firstAccount?.enrollment?.accountType === IAccountDtoAccountTypeEnum.HSA) {
      handleSetFormValues({ accountId: firstAccount?.accountOrder?.accountId });
    }
  }, [combinedAccountsData, handleSetFormValues]);
};

export default useSetupHsaAccount;
